import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getSplitAbTreatment } from '../utils/api';

export enum TreatmentTypes {
  OFF = 'off',
  ON = 'on',
}

function useGetSplitAbTreatment(featureName: string) {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['getSplitAbTreatment', featureName],
    queryFn: () => dispatch(getSplitAbTreatment({ featureName })),
    select(response) {
      // @ts-ignore
      return response.data.response?.treatment === TreatmentTypes.ON;
    },
  });
}

export function useGetIsIdvModuleEnabled() {
  const { data } = useGetSplitAbTreatment('RA_IDV_MODULE');
  return !!data;
}
